import React, { PropsWithChildren } from 'react'

import { gt } from '~/lib/gt'

import styles from './FormInput.module.css'

type Props = {
  className?: string
  errorMessage?: string
  label?: string
} & React.InputHTMLAttributes<HTMLInputElement>

export const FormInput = React.forwardRef<HTMLInputElement, PropsWithChildren<Props>>(
  ({ className, label, errorMessage, ...rest }, ref) => {
    const combinedClassName = `${styles.input} ${className ?? ''} ${errorMessage && styles.inputError}`

    return (
      <div className={styles.inputWrapper}>
        {label && <div className={styles.label}>{label}</div>}
        <input ref={ref} className={combinedClassName} {...rest} />
        {errorMessage && <p className={styles.error}>{gt.tp('Error', errorMessage)}</p>}
      </div>
    )
  }
)
